<template>

  <el-notification
    :notification="notification"
    :module="$t('modules.blog.title')"
    :date="notification.created_at"
    :title="$t('modules.blog.notifications.content_new', { content: notification.data.data.content_name })"
  >
    <div slot="actions">
      <el-notification-button
        :notification="notification"
        :callback="goToContent"
        :title="$t('modules.blog.notifications.btn_content_new')"
      />
    </div>
  </el-notification>

</template>

<script>

export default {
  tag: 'el-notification-blog-content_new',
  name: 'NotifBlogContentNew',
  props: {
    notification: {
      type: Object,
      required: true,
    }
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    goToContent (notification) {
      return this.$router.push({
        name: 'module.index',
        params: {
          world: this.world.id,
          module: 'blog',
          page: 'posts',
        },
        hash: '#' + notification.data.data.content_id,
      })
    },
  },
  computed: {
    world () {
      return this.$store.getters['auth/getWorld']
    },
  },
}
</script>

<style scoped lang="scss">

</style>
